import { configureStore } from '@reduxjs/toolkit'
import States from './Appslice';

export const store = configureStore({
  reducer: {
	  appState: States
  },
})
